import type { CellProps } from 'react-table';
import { FileIcon } from '@/components/icons/File';
import type { FilesTableItem } from './interfaces';
import ClickContainer from './ResultClickContainer';
import styles from './style/Cell.Name.module.css';

export default function Name({ row: { original: data } }: CellProps<FilesTableItem>) {
  return (
    <ClickContainer className={styles.overflowWrapper} item={data}>
      <div className={styles.root}>
        <FileIcon
          className={styles.icon}
          extension={data.metadata.extension} />
        <div className={styles.details}>
          <div className={styles.name}>{data.name}</div>
        </div>
      </div>
    </ClickContainer>
  );
}

export { Name };